import { Button, Link } from "@chakra-ui/react";
import { useDocumentResolver } from "../content-management/ContentManagementProvider";
import React, { useEffect, useState } from "react";
export const PimcoreLinkButton = (props) => {
    const [url, setUrl] = useState("");
    const documentResolver = useDocumentResolver();
    useEffect(() => {
        if (props.link.linktype === "internal") {
            documentResolver(props.link.path).then((url) => setUrl(url));
            return;
        }
        setUrl(props.link.path);
    }, [props.link]);
    return (React.createElement(Button, Object.assign({}, props, { as: Link, whiteSpace: "normal", wordBreak: "break-word", h: "auto", textAlign: "center", href: url, target: props.link.target, _before: { content: "none" } })));
};
